const UPLOAD_PREFIXES = ["/api/uploads/avatars/", "/uploads/avatars/"];
const STATIC_PROFILE_AVATAR_PREFIX = "/assets/profile-avatars/";
const STATIC_PROFILE_AVATAR_VERSION = "20260718-static-assets-fix";

const normalizeBaseOrigin = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";

  try {
    return new URL(raw).origin;
  } catch {
    return raw.replace(/\/+$/g, "");
  }
};

const getApiOrigin = () => {
  const envApiUrl = normalizeBaseOrigin(process.env.REACT_APP_API_URL);
  if (envApiUrl) return envApiUrl;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
};

export const resolveAvatarSrc = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(?:https?:)?\/\//i.test(raw) || /^data:image\//i.test(raw) || /^blob:/i.test(raw)) {
    return raw;
  }

  const normalizedPath = raw.startsWith("/") ? raw : `/${raw}`;
  if (normalizedPath.startsWith(STATIC_PROFILE_AVATAR_PREFIX)) {
    if (normalizedPath.includes("?v=") || normalizedPath.includes("&v=")) {
      return normalizedPath;
    }
    return `${normalizedPath}${normalizedPath.includes("?") ? "&" : "?"}v=${STATIC_PROFILE_AVATAR_VERSION}`;
  }

  const isUploadedAvatar = UPLOAD_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix));
  if (!isUploadedAvatar) return raw;

  const origin = getApiOrigin();
  return origin ? `${origin}${normalizedPath}` : normalizedPath;
};

export const getFirstResolvedAvatarSrc = (...values) => {
  for (let index = 0; index < values.length; index += 1) {
    const resolved = resolveAvatarSrc(values[index]);
    if (resolved) return resolved;
  }
  return "";
};
